import { Outlet } from "react-router-dom";
// hooks
import useOffSetTop from "@/core/hooks/useOffSetTop";
// config
import { HEADER } from "@/app/config-global";
// components
import Header from "./Header";

// ----------------------------------------------------------------------

export default function SimpleLayout() {
  const isOffset = useOffSetTop(HEADER.H_MAIN_DESKTOP);

  return (
    <>
      <Header isOffset={isOffset} />

      <Outlet />
    </>
  );
}
